import { GET_ENC, POST_ENC } from "../common/EncryptedHttp";
import { BASE_URL } from "../common/const";

// Eyelids / Lashes
export const GetEyelidsList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalSlitLamp/GetEyelidsList?` + params, null);

export const GetEyelidsDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalSlitLamp/GetEyelidsDetail?` + params, null);

export const CreateEyelids = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalSlitLamp/CreateEyelids`, data);

export const UpdateEyelids = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalSlitLamp/UpdateEyelids`, data);

export const DeleteEyelids = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalSlitLamp/DeleteEyelids`, data);

// Conjunctiva
export const GetConjunctivaList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalSlitLamp/GetConjunctivaList?` + params, null);

export const GetConjunctivaDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalSlitLamp/GetConjunctivaDetail?` + params, null);

export const CreateConjunctiva = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalSlitLamp/CreateConjunctiva`, data);

export const UpdateConjunctiva = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalSlitLamp/UpdateConjunctiva`, data);

export const DeleteConjunctiva = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalSlitLamp/DeleteConjunctiva`, data);

// Cornea
export const GetCorneaList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalSlitLamp/GetCorneaList?` + params, null);

export const GetCorneaDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalSlitLamp/GetCorneaDetail?` + params, null);

export const CreateCornea = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalSlitLamp/CreateCornea`, data);

export const UpdateCornea = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalSlitLamp/UpdateCornea`, data);

export const DeleteCornea = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalSlitLamp/DeleteCornea`, data);

// Anterior chamber
export const GetAnteriorChamberList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalSlitLamp/GetAnteriorChamberList?` + params, null);

export const GetAnteriorChamberDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalSlitLamp/GetAnteriorChamberDetail?` + params, null);

export const CreateAnteriorChamber = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalSlitLamp/CreateAnteriorChamber`, data);

export const UpdateAnteriorChamber = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalSlitLamp/UpdateAnteriorChamber`, data);

export const DeleteAnteriorChamber = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalSlitLamp/DeleteAnteriorChamber`, data);

// Iris / Pupil
export const GetIrisList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalSlitLamp/GetIrisList?` + params, null);

export const GetIrisDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalSlitLamp/GetIrisDetail?` + params, null);

export const CreateIris = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalSlitLamp/CreateIris`, data);

export const UpdateIris = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalSlitLamp/UpdateIris`, data);

export const DeleteIris = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalSlitLamp/DeleteIris`, data);

// Lens
export const GetLensList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalSlitLamp/GetLensList?` + params, null);

export const GetLensDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OpthalSlitLamp/GetLensDetail?` + params, null);

export const CreateLens = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalSlitLamp/CreateLens`, data);

export const UpdateLens = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalSlitLamp/UpdateLens`, data);

export const DeleteLens = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OpthalSlitLamp/DeleteLens`, data);